// src/features/tidsregistering/services/registrationCodes.js
import { apiClient } from '../../../services/api/client';

const BASE = '/api/v1/tidsregistering/registration-codes';

export const registrationCodesAPI = {
  createRegistrationCode: (data) =>
    apiClient.post(`${BASE}/`, data),

  getRegistrationCode: (registrationCodeId) =>
    apiClient.get(`${BASE}/${registrationCodeId}`),

  listForDepartment: () =>
    apiClient.get(`${BASE}/department`),

  updateRegistrationCode: (registrationCodeId, data) =>
    apiClient.put(`${BASE}/${registrationCodeId}`, data),

  deleteRegistrationCode: (registrationCodeId) =>
    apiClient.delete(`${BASE}/${registrationCodeId}`),

  seedDefaultCodes: () =>
    apiClient.post(`${BASE}/seed`),

  createReasonCodeType: (data) =>
    apiClient.post(`${BASE}/reason-code-types`, data),

  listReasonCodeTypes: () =>
    apiClient.get(`${BASE}/reason-code-types/department`),
};
